import { MutationTree } from 'vuex'
import { ProjectManagementUiMutation, ProjectManagementUiState } from './types'

export const mutations: MutationTree<ProjectManagementUiState> = {
  [ProjectManagementUiMutation.setInteracted](state, payload: boolean) {
    state.interacted = payload
  },
}
